import {
  take,
  put,
  call,
  all,
  takeLatest,
  takeEvery,
} from 'redux-saga/effects';
import { authActions as actions, notificationActions } from '../actions';
import { authService } from '../services';


/* Login Sagas */
function* handleUserLoginRequest() {
  const action = yield take(actions.userLoginRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(authService.userLogin, dataParams);
    if (res.isError) {
      yield put(actions.userLoginError(res));
        yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
     
    } else {
      yield put(actions.userLoginSuccess(res));
    }
  } catch (error) {
    yield put(actions.userLoginError());
      yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
  }
}

/* Logout Sagas */
function* handleLogoutRequest() {
  const action = yield take(actions.logoutRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(authService.logout, dataParams);
    if (res.isError) {
      yield put(actions.logoutError(res));
       yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    } else {
      yield put(actions.logoutSuccess(res));
    }
  } catch (error) {
    yield put(actions.logoutError());
     yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
  }
}

/* Reset Password Sagas */
function* handleResetPasswordRequest() {
  const action = yield take(actions.resetPasswordRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(authService.resetPassword, dataParams);
    if (res.isError) {
      yield put(actions.resetPasswordError(res));
      yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    } else {
      yield put(actions.resetPasswordSuccess(res));
      yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
    }
  } catch (error) {
    yield put(actions.resetPasswordError());
    yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
  }
}

/* Reset Password Sagas */
function* handleForgotPasswordRequest() {
  const action = yield take(actions.forgotPasswordRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(authService.forgotPassword, dataParams);
    if (res.isError) {
      yield put(actions.forgotPasswordError(res));
      yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    } else {
      yield put(actions.forgotPasswordSuccess(res));
      yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
    }
  } catch (error) {
    yield put(actions.forgotPasswordError());
    yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
  }
}

/* Send Otp Sagas */
function* handleSendOtpRequest() {
  const action = yield take(actions.sendOtpRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(authService.sendOtp, dataParams);
    if (res.isError) {
      yield put(actions.sendOtpError(res));
      yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    } else {
      yield put(actions.sendOtpSuccess(res));
      yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
    }
  } catch (error) {
    yield put(actions.sendOtpError());
    yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
  }
}


/* Verify Otp Sagas */
function* handleVerifyOtpRequest() {
  const action = yield take(actions.verifyOtpRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(authService.verifyOtp, dataParams);
    if (res.isError) {
      yield put(actions.verifyOtpError(res));
      yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    } else {
      yield put(actions.verifyOtpSuccess(res));
      yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
    }
  } catch (error) {
    yield put(actions.verifyOtpError());
    yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
  }
}

/* Verify Otp Sagas */
function* handleForgotPasswordForAdminRequest() {
  const action = yield take(actions.forgotPasswordForAdminRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(authService.forgotPasswordForAdmin, dataParams);
    if (res.isError) {
      yield put(actions.forgotPasswordForAdminError(res));
      yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    } else {
      yield put(actions.forgotPasswordForAdminSuccess(res));
      yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
    }
  } catch (error) {
    yield put(actions.forgotPasswordForAdminError());
    yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
  }
}

/* Verify Otp Sagas */
function* handleSwitchAccountsRequest() {
  const action = yield take(actions.switchAccountsRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(authService.switchAccounts, dataParams);
    if (res.isError) {
      yield put(actions.switchAccountsError(res));
      yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    } else {
      yield put(actions.switchAccountsSuccess(res));
      // yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
    }
  } catch (error) {
    yield put(actions.switchAccountsError());
    yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
  }
}


/*-----------Watchers-------------*/
function* handleGetUserLoginWatcher() {
  yield takeEvery(
    actions.userLoginRequest,
    handleUserLoginRequest,
  );
}

function* handleLogoutWatcher() {
  yield takeEvery(
    actions.logoutRequest,
    handleLogoutRequest,
  );
}

function* handleResetPasswordWatcher() {
  yield takeEvery(
    actions.resetPasswordRequest,
    handleResetPasswordRequest,
  );
}

function* handleForgotPasswordWatcher() {
  yield takeEvery(
    actions.forgotPasswordRequest,
    handleForgotPasswordRequest,
  );
}

function* handleSendOtpWatcher() {
  yield takeEvery(
    actions.sendOtpRequest,
    handleSendOtpRequest,
  );
}

function* handleVerifyOtpWatcher() {
  yield takeEvery(
    actions.verifyOtpRequest,
    handleVerifyOtpRequest,
  );
}


function* handleForgotPasswordForAdminWatcher() {
  yield takeEvery(
    actions.forgotPasswordForAdminRequest,
    handleForgotPasswordForAdminRequest,
  );
}

function* handleSwitchAccountsWatcher() {
  yield takeEvery(
    actions.switchAccountsRequest,
    handleSwitchAccountsRequest,
  );
}


function* rootAuthSaga() {
  yield all([
    handleUserLoginRequest(),
    handleGetUserLoginWatcher(),

    handleLogoutRequest(),
    handleLogoutWatcher(),

    handleResetPasswordRequest(),
    handleResetPasswordWatcher(),

    handleForgotPasswordRequest(),
    handleForgotPasswordWatcher(),

    handleSendOtpRequest(),
    handleSendOtpWatcher(),

    handleVerifyOtpRequest(),
    handleVerifyOtpWatcher(),

    handleForgotPasswordForAdminRequest(),
    handleForgotPasswordForAdminWatcher(),

    handleSwitchAccountsRequest(),
    handleSwitchAccountsWatcher(),
  ]);
}

export default rootAuthSaga;
